import useSelectEntities from '@hooks/useSelectEntities'
import { CampaignQuoteModel } from '@models/types'

type UseBulkUpdateProviderPriceListsModalOptions = {
  invalidPrices?: CampaignQuoteModel['invalidItems'],
}

function useBulkUpdateProviderPriceListsModal(options: UseBulkUpdateProviderPriceListsModalOptions = {}) {
  const { invalidPrices = [] } = options

  const initSelectedIds = invalidPrices.filter(item => item.current_price !== 0)
    .map(item => item.campaign_quote_item_id)

  const unselectEntitiesPayload = useSelectEntities({ initSelectedIds })
  const {
    callbacks: {
      deselectAll,
      selectAllIds,
      toggleId,
    },
    selectedEntityIds,
    hasSelectedEntities,
  } = unselectEntitiesPayload

  const allSelected = (selectedEntityIds.length === initSelectedIds.length && selectedEntityIds.length > 0)

  return {
    callbacks: {
      deselectAllItems: () => deselectAll(),
      selectAllItems: () => selectAllIds(initSelectedIds),
      toggleId: (entityId: number) => toggleId(entityId),
    },
    allSelected,
    hasSelectedEntities,
    initSelectedIds,
    selectedEntityIds,
  }
}

export default useBulkUpdateProviderPriceListsModal
